import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-162b0246"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "root",
  class: "stream-container"
}
const _hoisted_2 = ["srcObject"]
const _hoisted_3 = ["srcObject"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("video", {
      class: "local-stream stream",
      srcObject: _ctx.localStream,
      muted: "",
      autoplay: ""
    }, null, 8, _hoisted_2),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.remoteStreams, (stream, key) => {
      return (_openBlock(), _createElementBlock("video", {
        class: "stream",
        key: key,
        srcObject: stream,
        autoplay: ""
      }, null, 8, _hoisted_3))
    }), 128))
  ], 512))
}